import { Installation } from 'src/Libs/installations'
import { isFlowTheme } from 'src/Libs/utils'
import { UserData } from 'src/State/User/UserModel'

/**
 * Function which checks if the current user can assign a new owner to the installation.
 */
export const canAssignNewOwner = (installation: Installation, user?: UserData): boolean => {
  if (!isFlowTheme || !user) return false

  if (user?.level === 'USER' || user?.level === 'PARTNER') return false

  if (!installation.ownerAccountId) return true

  const isInstallerOwnerOfInstallation = installation.ownerAccountId === user?.ssoId
  if (isInstallerOwnerOfInstallation) return true

  return false
}
